import './course-page-link.scss';

import { t } from 'i18next';
import { FC } from 'react';

import Icon from '@/presentation/components/icon/icon';

const CoursePageLink: FC<{
  display?: boolean;
  url?: string;
  onClick?: () => void;
}> = ({ display, onClick, url }) => {
  return (
    <div className={`course-page-link ${!display ? 'hidden' : ''}`}>
      <a
        href={url}
        data-testid="page-link"
        tabIndex={5}
        onClick={onClick}
        target="_blank"
        aria-label={t('pages.microcertificate.seeCoursePage') || ''}
        rel="noreferrer"
      >
        <Icon name="link" /> {t('pages.microcertificate.seeCoursePage')}
      </a>
    </div>
  );
};

CoursePageLink.defaultProps = {
  display: true,
  onClick: () => {
    /* */
  },
};

export default CoursePageLink;
